import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';

import { ReactComponent as CloseIcon } from '@pkg/assets/icons/v2/close.svg';
import { publish } from '@pkg/components/Sections/Profile/pubSub';
import {
    glLiquidIdExpandedPreview,
    glLiquidIDOrbitControls,
    glLiquidIDRotate,
} from '@pkg/components/Sections/Profile/pubSub/constants';
import { useAppSelector } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import { LiquidIDSection as PrototypeLiquidIDSection } from '../../../Prototype';

import { CloseButton, Wrapper } from './styles';

const LiquidIDSection = () => {
    const { desktop } = useMediaQuery();
    const { liquidIDExpandedPreview } = useAppSelector((state) => state.yatPage);

    useEffect(() => {
        // If touch device - only expanded preview can orbit cube, else all states but editing liquid id
        publish(glLiquidIDOrbitControls, true);
        publish(glLiquidIDRotate, true);
        publish(glLiquidIdExpandedPreview, liquidIDExpandedPreview);
    }, [liquidIDExpandedPreview, desktop]);

    return (
        <Wrapper>
            <CloseButton as={Link} to={window.location.pathname}>
                <CloseIcon aria-hidden="true" />
            </CloseButton>
            <PrototypeLiquidIDSection />
        </Wrapper>
    );
};

export default LiquidIDSection;
